export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '最新入口',
    slug: 'latest-access',
    description: '获取17c.com最新官方访问地址和备用入口，确保您随时畅通访问。',
    icon: 'ri-links-line',
    articleCount: 15,
  },
  {
    id: 'cat-2',
    name: '使用指南',
    slug: 'usage-guide',
    description: '详细的使用教程和操作指南，帮助新老用户快速上手17c.com的各项功能。',
    icon: 'ri-book-open-line',
    articleCount: 23,
  },
  {
    id: 'cat-3',
    name: '安全须知',
    slug: 'security-tips',
    description: '了解17c.com的安全防护措施和用户安全操作建议，保障您的访问安全。',
    icon: 'ri-shield-check-line',
    articleCount: 12,
  },
  {
    id: 'cat-4',
    name: '常见问题',
    slug: 'faq',
    description: '汇总用户在使用17c.com过程中遇到的常见问题及解决方案。',
    icon: 'ri-question-answer-line',
    articleCount: 30,
  },
  {
    id: 'cat-5',
    name: '平台动态',
    slug: 'platform-news',
    description: '关注17c.com平台的最新动态、功能更新和重要公告。',
    icon: 'ri-news-line',
    articleCount: 18,
  },
  {
    id: 'cat-6',
    name: '社区交流',
    slug: 'community',
    description: '加入17c.com用户社区，与其他用户交流使用心得和技巧。',
    icon: 'ri-group-line',
    articleCount: 25,
  },
];